// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__S6W2M","footer":"ModalFilter_footer__E8KUk"};